<h2 class="font-weight-bold mb-4 mt-4 headingStyle font-italic">Best Seller</h2>
<div id="carouselExampleControls" class="carousel slide" data-ride="carousel" data-aos="fade-right"
  data-aos-duration="1500">
  <div class="carousel-inner">
    <div class="carousel-item active">
      <div class="row">
        <div *ngFor="let item of product$ | async | slice: 4 : 8 " class="col-3"><img class="d-block w-100"
            src="{{item.image}}" alt="First slide"></div>
      </div>
    </div>
    <div class="carousel-item">
      <div class="row">
        <div *ngFor="let item of product$ | async | slice: 1 : 5 " class="col-3"><img class="d-block w-100"
            src="{{item.image}}" alt="First slide"></div>
      </div>
    </div>
  </div>
  <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
    <span class="sr-only">Previous</span>
  </a>
  <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span class="carousel-control-next-icon" aria-hidden="true"></span>
    <span class="sr-only">Next</span>
  </a>
</div>


<h2 class="font-weight-bold mb-4 mt-4 headingStyle font-italic">From the Shop</h2>
<section class="row pb-5 mb-4" *ngIf="product$ | async as product">
  <div *ngFor="let item of product | slice: firstIndex : lastIndex ; " class="col-md-4 mb-4" data-aos="fade-right"
    data-aos-duration="1500">
    <div class="card rounded shadow border-0">
      <div class="card-body p-4">
        <div class="zoomPicture mb-3">
          <img src="{{item.image}}" alt="{{item.name}}" class=" mx-auto card-img-top img-fluid">
        </div>
        <h5> <a [routerLink]="['/product/' + item._id]" class="text-dark text-uppercase">{{item.name}}</a></h5>
        <p class="small text-muted font-italic">{{item.preview}}</p>
        <div>
          <h5>$ {{item.price}}</h5>
        </div>
        <div class="text-right">
          <button class="btn" [routerLink]="['/product/' + item._id]">Detail</button>
          <button class="btn cartStyle" (click)="addCart(item._id)"><i class="fa fa-shopping-cart fa-lg"
              aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
  <nav class="ml-3 col-md-12 ">
    <ul class="pagination justify-content-center">
      <li *ngFor="let i of arrProduct(product.length); let in = index;" class="page-item">
        <a class="page-link btn " (click)="paginationIndex(in)">{{in + 1}}</a>
      </li>
    </ul>
  </nav>
</section>
